export { default as adminListHandleDelete } from './adminListHandleDelete';

export type {
  AdminListHandleDeletePayload,
  AdminListHandleDeleteFunction,
} from './adminListHandleDelete.type';
